import styled from "styled-components";

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  align-items: flex-start;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  font-family: ${(props) => props.theme.fontFamilies.primaryFont};
  font-size: 1.4rem;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0 5rem 5rem 5rem;
  scrollbar-width: none;
  width: 45rem;
  -ms-overflow-style: none;

  .submitButton {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: 2rem;
    width: 100%;

    .block-hint {
      color: ${(props) => props.theme.colors.red};
      font-size: 1.4rem;
      text-align: center;
    }
  }

  .delete-vehicle {
    color: ${(props) => props.theme.colors.supportRed};
    font-family: ${(props) => props.theme.colors.primaryFont};
    align-items: flex-end;
    cursor: pointer;
    display: flex;
    font-size: 1.2rem;
    font-weight: 600;
    justify-content: flex-end;
    margin-bottom: 1rem;
    margin-top: 1.8rem;
    text-align: end;
  }

  .delete-vehicle img {
    filter: invert(20%) sepia(50%) saturate(50) hue-rotate(672deg)
      brightness(90%) contrast(130%);
    padding-right: 0.9rem;
  }

  .request-options {
    display: flex;
    gap: 2rem;
  }
`;

export const AppointmentInfo = styled.div`
  background-color: rgba(255, 255, 254, 1);
  font-size: 1.8rem;
  padding-bottom: 2rem;
  padding-top: 6rem;

  p {
    margin: 0;
  }

  .appointment-id {
    color: ${(props) => props.theme.colors.primaryBlue};
    font-weight: 600;
  }

  .appointment-title {
    font-weight: 800;
    margin-bottom: 1.2rem;
    margin-top: 0.5rem;
  }
`;

interface IStatusDiv {
  status?: string;
}
export const StatusDiv = styled.div<IStatusDiv>`
  ${(props) => {
    const status = props.status.toLowerCase();
    let color, backgroundColor;
    if (status === "problem") {
      color = props.theme.colors.supportRed;
      backgroundColor =
        props.theme.colors.supportRed + props.theme.transparencies.p10;
    } else if (status === "warning") {
      color = props.theme.colors.blackTextBody;
      backgroundColor =
        props.theme.colors.supportYellow + props.theme.transparencies.p30;
    } else if (status === "ok") {
      color = props.theme.colors.betterGreen;
      backgroundColor =
        props.theme.colors.betterGreen + props.theme.transparencies.p10;
    } else {
      color = props.theme.colors.gray;
      backgroundColor =
        props.theme.colors.gray72 + props.theme.transparencies.p20;
    }
    return `
      span {
        background-color: ${backgroundColor};
        color: ${color};
        font-size: 1.1rem;
        font-weight: 600;
        padding: 0.6rem;
      }
      width: max-content;
  `;
  }}
`;

export const DetailInfo = styled.div`
  position: relative;
  width: 100%;

  p {
    margin: 0;
  }
`;

export const VehiclesInfo = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin-top: 3.6rem;
  width: 100%;

  h1 {
    font-size: 1.4rem;
    font-weight: 700;
    margin-bottom: 1.2rem;
  }

  .vehicle-label {
    color: ${(props) =>
      props.theme.colors.blackTextBody + props.theme.transparencies.p30};
    font-size: 1.2rem;
    font-weight: 700;
    margin-bottom: 0.6rem;
  }
  overflow-y: auto;
`;

export const VehicleCard = styled.div`
  color: ${(props) => props.theme.colors.gray72};
  border-radius: 0.8rem;
  border: solid 1px;
  display: grid;
  font-weight: 500;
  grid-template: 1fr;
  margin-bottom: 0.8rem;
  padding-left: 1rem;
  padding: 1.4rem 1.6rem;
  width: 100%;

  p {
    color: black;
    margin: 0;
  }
`;

export const VehicleRow = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  display: flex;
  justify-content: space-between;

  h2 {
    ${(props) => `
    color: ${props.theme.colors.blackTextBody + props.theme.transparencies.p30};
  `}
    font-size: 1.2rem;
    font-weight: 700;
    margin: 0.5rem 0.5rem;
  }

  &.row-title {
    margin-top: 2rem;
  }

  .add-vehicle {
    color: ${(props) => props.theme.colors.blackTextBody};
    cursor: pointer;
    display: flex;
    font-family: ${(props) => props.theme.colors.primaryFont};
    font-size: 1.6rem;
    font-weight: 600;
  }

  .vehicle-type {
    margin-right: 1.5rem;
  }
`;

export const MainButton = styled.button`
  ${(props) => `
  background-color: ${
    props.disabled
      ? props.theme.colors.accentGreen + props.theme.transparencies.p20
      : props.theme.colors.accentGreen
  };
  color: ${props.theme.colors.white};
  cursor: ${props.disabled ? "not-allowed" : "pointer"};
  font-family: ${props.theme.fontFamilies.primaryFont};
`}
  align-items: center;
  border: none;
  border-radius: 8px;
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  min-height: 6.4rem;
  justify-content: center;
  width: 100%;

  & > img {
    height: 5rem;
    width: 5rem;
  }
`;

export const Row = styled.div`
  ${(props) => `
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  align-items: center;
  align-self: center;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0rem;

  h2 {
    ${(props) => `
      color: ${
        props.theme.colors.blackTextBody + props.theme.transparencies.p30
      };
    `}
    font-size: 1.2rem;
    font-weight: 700;
    margin-bottom: 0rem;
  }

  select {
    height: 5rem;
    padding: 1.3rem 0.5rem 1.3rem 1.3rem;
  }

  h2.add-vehicle {
    color: ${(props) => props.theme.colors.blackTextBody};
    font-family: ${(props) => props.theme.colors.primaryFont};
    cursor: pointer;
    display: flex;
    font-size: 1.6rem;
    font-weight: 600;
    margin-bottom: 1.2rem;
    margin-left: 0.5rem;
  }
`;
interface IInput {
  hasError?: any;
}
export const Input = styled.input<IInput>`
  ${(props) => `
    color: ${props.theme.colors.blackTextTitle};
    font-family: ${props.theme.fontFamilies.primaryFont};
    background-color: ${
      props.disabled
        ? props.theme.colors.gray72 + props.theme.transparencies.p58
        : props.theme.colors.white
    }; `}
  border-color: transparent;
  border-radius: 8px;
  border: none;
  box-shadow: 0px 5px 30px rgb(231 231 234 / 62%);
  font-size: 1.4rem;
  font-weight: 500;
  height: 5rem;
  padding-left: 1.5rem;
  width: 95%;
  ::placeholder {
    color: ${(props) => props.theme.colors.gray72};
  }
`;

export const CloseButton = styled.button`
  all: unset;
  cursor: pointer;
  margin-left: 38rem;
  margin-top: -2rem;
  top: 0;
  zoom: 1.1;
`;

export const WithdrawalByHandContainer = styled.div`
  align-items: center;
  color: ${(props) => props.theme.colors.blackTextBody};
  display: flex;
  font-family: ${(props) => props.theme.colors.primaryFont};
  font-size: 1.5rem;
  font-weight: 600;
  gap: 1rem;
  margin-top: 2rem;
`;

export const CheckBox = styled.input`
  cursor: pointer;
  height: 1.5rem;
  margin: 3rem;
  width: 1.5rem;
`;

interface IGrayBox {
  height?: string;
  disableOutline?: any;
  width?: string;
}
export const GrayBox = styled.div<IGrayBox>`
  ${(props) => `
    background-color: ${props.theme.colors.backgroundGray2};
    border: none;
    color: ${props.theme.colors.blackTextTitle};
    height: ${props.height ? props.height : "4.5rem"};
    outline: ${props.disableOutline ? "none" : ""};
    width: ${props.width};
  `}
  align-items: center;
  border-radius: 0.8rem;
  display: flex;
  font-size: 10.5px;
  font-weight: 500;
  padding: 1.5rem;
`;
